
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxFigeac = () => {
  return (
    <CityMetauxPage
      cityName="Figeac"
      departmentName="Lot"
      departmentCode="46"
      region="Occitanie"
      description="Notre connaissance du patrimoine industriel de Figeac et de sa région nous permet de valoriser au mieux vos métaux issus de l'artisanat local et de l'industrie."
      specialities={[
        "Métaux issus de l'artisanat traditionnel",
        "Cuivre et laiton de bâtiments historiques",
        "Ferraille industrielle et agricole",
        "Métaux précieux et alliages spéciaux"
      ]}
      nearbyAreas={[
        "Capdenac-Gare", "Cajarc", "Saint-Céré", "Maurs", "Lacapelle-Marival", "Sousceyrac"
      ]}
      heroImage="https://images.unsplash.com/photo-1433086966358-54859d0ed716?w=1280&q=80"
    />
  );
};

export default AchatMetauxFigeac;
